import Constants from "../Base/Constants";
import GrimoireInterface from "../Interface/GrimoireInterface";
import NodeInterface from "./NodeInterface";
import GomlNode from "../Node/GomlNode";
/**
 * Provides interfaces to treat whole goml tree for each.
 */
class GomlInterface {
    constructor(rootNodes) {
        this.rootNodes = rootNodes;
    }
    getNodeById(id) {
        return this.rootNodes.map(root => GomlNode.fromElement(root.element.ownerDocument.getElementById(id)));
    }
    queryFunc(query) {
        return new NodeInterface(this._queryNodes(query));
    }
    _queryNodes(query) {
        return this.rootNodes.map(root => {
            const nodelist = root.element.ownerDocument.querySelectorAll(query);
            const nodes = [];
            for (let i = 0; i < nodelist.length; i++) {
                const id = nodelist.item(i).getAttribute(Constants.x_gr_id);
                if (id) {
                    const node = GrimoireInterface.nodeDictionary[id];
                    if (node) {
                        nodes.push(node);
                    }
                }
            }
            return nodes;
        });
    }
}
export default GomlInterface;



// WEBPACK FOOTER //
// ./src/Interface/GomlInterfaceImpl.ts